export default "https://d3fbpisbzpk8wt.cloudfront.net/202511712253/receiptScanOk-bundle-e9790f228413b549290d2da8ab226fc9.png";